/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarStacked: {
  name: 'bar-stacked';
  data: string;
} = {
  name: 'bar-stacked',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm-7 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm0 6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-6 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm13-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm1-7a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4ZM5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
